// extracted by mini-css-extract-plugin
export default {"root":"FilterDrawerHeader_root__PLUpQ","title":"FilterDrawerHeader_title__zITVf"};